import { Network } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const NetworkIcon = createLucideIcon(Network);
